<template>
  <div>
    <!-- Configurations -->
    <el-row :gutter="4">
      <el-col :span="16">

        <el-card shadow="never">
          <el-form :inline="true" label-position="left" label-width="80px"
            class="d-flex justify-space-between align-items-center">
            
            <el-form-item label="經銷商" class="pr-4">
              <el-select v-model="selectedSiId" placeholder="（請選擇）" clearable size="small" @change="applySi">
                <el-option v-for="si in sis"
                  :key="si.si_id" :label="si.si_name" :value="si.si_id">
                </el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="">
              <el-button type="warning" round icon="el-icon-edit"
                :disabled="!selectedSiId"
                @click="showSiEditDialog">
                設定經銷商費率公式
              </el-button>
              <!-- <el-button type="danger" round icon="el-icon-circle-check">套用</el-button> -->
            </el-form-item>
            
          </el-form>

        </el-card>

      </el-col>

      <el-col :span="8">

        <!-- <el-card shadow="never">
          <el-form :inline="true" label-position="left" label-width="80px" @submit.native.prevent>
            
            <el-form-item label="搜尋店家">
              <el-input v-model="searchKeyword" placeholder="（ID或關鍵字）" @change="updateSearchKeyword"></el-input>
            </el-form-item>
            
          </el-form>

        </el-card> -->

      </el-col>
    </el-row>
    <br>

    <!-- Shop list -->
    <el-row>
      <el-col :span="24">

        <!-- <data-table
          :data="shops" :cols="cols" :total="total" :loading="isLoading"
          :on-sort-change="onSortChanged" :on-page-request="onPageRequest"
          :rows-per-page-options="[10, 20, 30]"
          :on-rows-per-page-change="onRowsPerPageChange">

          <div slot="formula" slot-scope="{row}">
            {{ row.formula_name }}<br>
            <el-tag :type="sendPeriodStyle(row.send_period)" size="mini">
              {{ row.send_period | sendPeriodLiteral }}
            </el-tag>
          </div>

          <div slot="si_formula" slot-scope="{row}">
            {{ row.si_formula_name }}
            <br>
            <el-tag :type="sendPeriodStyle(row.si_send_period)" size="mini">
              {{ row.si_send_period | sendPeriodLiteral }}
            </el-tag>
          </div>

          <div slot="Actions" slot-scope="{row}">
            <el-button type="info" icon="el-icon-edit" circle size="small" @click="showShopEditDialog(row)"></el-button>
            <el-button type="primary" icon="el-icon-message" circle size="small" @click="showShopMailingListConfigDialog(row)"></el-button>
            <el-button type="danger" icon="now-ui-icons ui-1_send" round size="small" @click="showExportDialog(row)">匯出／寄送</el-button>
          </div>

        </data-table> -->

        <SSRTable ref="list-shop-settings" :data-url="urlShopSettings" :schema="cols" data-key="shops"
          :search-on="['id', 'shop_name']">

          <div slot="formula_name" slot-scope="{row}">
            {{ row.formula_name }}<br>
            <el-tag :type="sendPeriodStyle(row.send_period)" size="mini">
              {{ row.send_period | sendPeriodLiteral }}
            </el-tag>
          </div>

          <div slot="si_formula_name" slot-scope="{row}">
            {{ row.si_formula_name }}
            <br>
            <el-tag :type="sendPeriodStyle(row.si_send_period)" size="mini">
              {{ row.si_send_period | sendPeriodLiteral }}
            </el-tag>
          </div>

          <div slot="actions" slot-scope="{row}">
            <el-button type="info" icon="el-icon-edit" circle size="small" @click="showShopEditDialog(row)"></el-button>
            <el-button type="primary" icon="el-icon-message" circle size="small" @click="showShopMailingListConfigDialog(row)"></el-button>
            <el-button type="danger" icon="now-ui-icons ui-1_send" round size="small" @click="showExportDialog(row)">匯出／寄送</el-button>
          </div>
        </SSRTable>
      </el-col>
    </el-row>

    <!-- Dialog - Edit SI formula -->
    <el-dialog :title="`設定 ${dialog.siEdit.si.si_name}`"
      :visible.sync="dialog.siEdit.show" width="40%">
      <el-form label-position="left" label-width="80px">
        
        <el-form-item label="費率公式">
          <el-select v-model="dialog.siEdit.selectedFormulaId" size="small">
            <el-option v-for="f in formulas"
              :key="f.id" :label="f.name" :value="f.id">
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="寄送週期">
          <el-select v-model="dialog.siEdit.selectedSendPeriod" size="small">
            <el-option v-for="sp in sendPeriodOptions"
              :key="sp.val" :label="sp.label" :value="sp.val">
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item>
          <el-checkbox v-model="dialog.siEdit.applyToShops">一併更新所有旗下店家的公式與寄送週期</el-checkbox>
        </el-form-item>

      </el-form>

      <span slot="footer">
        <el-button type="primary" @click="submitSiFormula">OK</el-button>
      </span>
    </el-dialog>

    <!-- Dialog - Edit shop formula -->
    <el-dialog :title="`設定 ${dialog.shopEdit.shop.shop_name}`"
      :visible.sync="dialog.shopEdit.show" width="40%">
      <el-form label-position="left" label-width="80px">
        
        <el-form-item label="費率公式">
          <el-select v-model="dialog.shopEdit.selectedFormulaId" size="small">
            <el-option v-for="f in formulas"
              :key="f.id" :label="f.name" :value="f.id">
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="寄送週期">
          <el-select v-model="dialog.shopEdit.selectedSendPeriod" size="small">
            <el-option v-for="sp in sendPeriodOptions"
              :key="sp.val" :label="sp.label" :value="sp.val">
            </el-option>
          </el-select>
        </el-form-item>

      </el-form>

      <span slot="footer">
        <el-button type="primary" @click="submitShopFormula">OK</el-button>
      </span>
    </el-dialog>

    <!-- Dialog - Config shop mailing list -->
    <el-dialog :title="`收件人設定：${dialog.mailing.ml.shop_name}`"
      :visible.sync="dialog.mailing.show" width="50%">
      <el-form label-position="left" label-width="240px">

        <el-form-item label="店家Email（預設收件人）">
          <el-input v-model="dialog.mailing.ml.email" :disabled="true"></el-input>
        </el-form-item>
        
        <el-form-item label="收件人（會取代店家Email）">
          <el-input v-model="dialog.mailing.recipient"></el-input>
        </el-form-item>

        <el-form-item label="副本收件人（多個請以逗號分隔）">
          <el-input v-model="dialog.mailing.ccs"></el-input>
        </el-form-item>

      </el-form>

      <span slot="footer">
        <el-button type="primary" @click="submitMailingList">OK</el-button>
      </span>
    </el-dialog>

    <!-- Dialog - Download/Send Report -->
    <el-dialog :title="`下載／寄送報表 ＠ ${dialog.export.shop.shop_name}`" :visible.sync="dialog.export.show" width="50%">

      <el-form label-position="left" label-width="240px">
        <span v-if="errorMessage" style="color:red">{{ errorMessage }}</span>
        <span v-else>最大可撈取區間為3個月</span>

        <el-form-item label="日期區間">
          <el-date-picker type="daterange" v-model="dialog.export.pickedDates"
            range-separator="～" start-placeholder="開始日期" end-placeholder="結束日期"
            :picker-options="datePickerOptions">
          </el-date-picker>
        </el-form-item>
        
        <el-form-item>
          <el-checkbox v-model="dialog.export.sendMode">以Email寄送報表</el-checkbox>
        </el-form-item>

        <el-form-item label="收件人（預設為店家Email）">
          <el-input v-model="dialog.export.recipient" :disabled="!dialog.export.sendMode"></el-input>
        </el-form-item>

        <el-form-item label="寄件副本（多個請以逗號分隔）">
          <el-input v-model="dialog.export.ccs" :disabled="!dialog.export.sendMode"></el-input>
        </el-form-item>

      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button type="warning" icon="el-icon-download" :disabled="errorMessage" @click="exportReport">下載</el-button>
        <el-button type="danger" icon="el-icon-message" :disabled="errorMessage || !dialog.export.sendMode" @click="sendReport">寄送</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>
// import DataTable from 'src/components/DataTable';
import SSRTable from 'src/components/SSRTable';

import axios from 'axios';
import moment from 'moment';

export default {
  components: {
    // DataTable
    SSRTable
  },

  mounted() {
    this.fetchFormulas();
    this.fetchSis();
    // this.refreshShopSettingsList();
  },

  methods: {
    refreshShopSettingsList() {
      this.$refs['list-shop-settings'].loadData();
    },

    fetchSis() {
      this.isLoading = true;
      axios.get(
        `${process.env.VUE_APP_APIHOST}/${this.userType}/qcm/sis`
      )
      .then(response => {
        // console.log('GET SIs', response.data);
        this.sis = response.data;
      })
      .catch(err => {
        this.$notify.error({
          title: '查詢經銷商列表錯誤',
          message: err.data.message
        });
      })
      .finally(() => { this.isLoading = false });
    },
    fetchFormulas() {
      this.isLoading = true;
      axios.get(
        `${process.env.VUE_APP_APIHOST}/${this.userType}/qcm/formulas`
      )
      .then(response => {
        // console.log('GET formulas', response.data);
        this.formulas = response.data;
      })
      .catch(err => {
        this.$notify.error({
          title: '查詢費率公式列表錯誤',
          message: err.data.message
        });
      })
      .finally(() => { this.isLoading = false });
    },

    applySi() {
      // console.warn('this.selectedSiId', this.selectedSiId);
      // this.refreshShopSettingsList();
    },
    // onSortChanged({ prop, key, order }) {
    //   let ordering = order === 'ascending'? 'asc': 'desc';
    //   this.sort = `${prop}:${ordering}`;
    //   console.warn(`Sort option changed`, this.sort);
    //   this.refreshShopSettingsList();
    // },
    // onPageRequest(page) {
    //   this.startIndex = (page - 1) * this.limit;
    //   this.refreshShopSettingsList();
    // },
    // onRowsPerPageChange(rpp) {
    //   this.limit = rpp;
    //   this.refreshShopSettingsList();
    // },
    // updateSearchKeyword() {
    //   // console.warn(`updateSearchKeyword`, this.searchKeyword);
    //   this.refreshShopSettingsList();
    // },

    showSiEditDialog() {
      let si = this.sis.find(si => { return si.si_id == this.selectedSiId; });
      this.dialog.siEdit.si = si;
      this.dialog.siEdit.selectedFormulaId = si.default_formula_id;
      this.dialog.siEdit.selectedSendPeriod = si.default_send_period;
      this.dialog.siEdit.show = true;
    },
    showShopEditDialog(_shop) {
      this.dialog.shopEdit.shop = _shop;
      this.dialog.shopEdit.selectedFormulaId = _shop.formula_id;
      this.dialog.shopEdit.selectedSendPeriod = _shop.send_period;
      this.dialog.shopEdit.show = true;
    },
    showShopMailingListConfigDialog(_shop) {
      this.dialog.mailing.show = true;
      axios.get(
        `${process.env.VUE_APP_APIHOST}/${this.userType}/qcm/shops/${_shop.id}/mailing-list`
      )
      .then(response => {
        let ml = response.data;
        this.dialog.mailing.ml = ml;
        this.dialog.mailing.recipient = ml.recipient || '';
        this.dialog.mailing.ccs = ml.cc_recipients? ml.cc_recipients.join(','): '';
      })
      .catch(err => {
        this.dialog.mailing.show = false;
        this.$notify.error({
          title: `無法取得店家 ${_shop.shop_name} 的收件人設定。`,
          message: err.data.message
        });
      });
    },
    showExportDialog(_shop) {
      axios.get(
        `${process.env.VUE_APP_APIHOST}/${this.userType}/qcm/shops/${_shop.id}/mailing-list`
      )
      .then(response => {
        let ml = response.data;
        this.dialog.export.ccs = ml.cc_recipients? ml.cc_recipients.join(','): '';
      })
      .catch(err => {
        this.$notify.error({
          title: `無法取得店家 ${_shop.shop_name} 的收件人設定。`,
          message: err.data.message
        });
      });
      this.dialog.export.shop = _shop;
      this.dialog.export.recipient = _shop.email;
      this.dialog.export.show = true;
    },

    submitSiFormula() {
      let si = this.dialog.siEdit.si;
      axios.put(
        `${process.env.VUE_APP_APIHOST}/${this.userType}/qcm/sis`
        + `/${si.si_id}/formula`,
        { 
          "fId": this.dialog.siEdit.selectedFormulaId, "period": this.dialog.siEdit.selectedSendPeriod,
          "applyToShops": this.dialog.siEdit.applyToShops
        }
      )
      .then(response => {
        this.dialog.siEdit.si.default_formula_id = this.dialog.siEdit.selectedFormulaId;
        this.dialog.siEdit.si.default_send_period = this.dialog.siEdit.selectedSendPeriod;
        this.$message({
          type: 'success',
          message: `經銷商 ${si.si_name} 的預設費率公式與寄送週期已更新。`
        });
        //WARNING: Force a list refresh.
        this.refreshShopSettingsList();
      })
      .catch(err => {
        this.$notify.error({
          title: `無法設定經銷商 ${si.si_name} 的預設費率公式與寄送週期。`,
          message: err.data.message
        });
      });
      this.dialog.siEdit.show = false;
    },
    submitShopFormula() {
      let shop = this.dialog.shopEdit.shop;
      axios.put(
        `${process.env.VUE_APP_APIHOST}/${this.userType}/qcm/shops`
        + `/${shop.id}/formula`,
        { "fId": this.dialog.shopEdit.selectedFormulaId, "period": this.dialog.shopEdit.selectedSendPeriod }
      )
      .then(response => {
        this.dialog.shopEdit.shop.formula_id = this.dialog.shopEdit.selectedFormulaId;
        this.dialog.shopEdit.shop.send_period = this.dialog.shopEdit.selectedSendPeriod;
        this.$message({
          type: 'success',
          message: `店家 ${shop.shop_name} 的費率公式與寄送週期已更新。`
        });
        //WARNING: Force a list refresh.
        this.refreshShopSettingsList();
      })
      .catch(err => {
        this.$notify.error({
          title: `無法設定店家 ${shop.shop_name} 的費率公式與寄送週期。`,
          message: err.data.message
        });
      });
      this.dialog.shopEdit.show = false;
    },
    submitMailingList() {
      let recipient = this.dialog.mailing.recipient.length? this.dialog.mailing.recipient: undefined;
      let ccs = this.dialog.mailing.ccs.length? this.dialog.mailing.ccs: undefined;
      if (!recipient && !ccs) {
        alert('您沒有輸入任何資料！');
        return;
      }

      let shopId = this.dialog.mailing.ml.id;
      let shopName = this.dialog.mailing.ml.shop_name;
      axios.put(
        `${process.env.VUE_APP_APIHOST}/${this.userType}/qcm/shops/${shopId}/mailing-list`,
        {
          "recipient": recipient,
          "ccRecipients": ccs? ccs.split(','): ccs
        }
      )
      .then(response => {
        console.log('submitMailingList response', response.data);
        this.$message({
          type: 'success',
          message: `店家 ${shopName} 的收件人設定已更新。`
        });
        //WARNING: Force a list refresh.
        this.refreshShopSettingsList();
      })
      .catch(err => {
        this.$notify.error({
          title: `無法設定店家 ${shopName} 的收件人。`,
          message: err.data.message
        });
      });
      this.dialog.mailing.show = false;
    },
    exportReport() {
      let shopId = this.dialog.export.shop.id;
      let from = moment(this.dialog.export.pickedDates[0]).format('YYYYMMDD');
      let to = moment(this.dialog.export.pickedDates[1]).format('YYYYMMDD');
      // if  ( moment(this.dialog.export.pickedDates[1]).diff( moment(this.dialog.export.pickedDates[0]), 'days') > 100 ) {
      //   this.$notify.error({
      //     //title: `報表區間過大`,
      //     message: '最大可撈取報表區間為3個月'
      //   });
      //   return; 
      // }
      // window.open(
      //   `${process.env.VUE_APP_APIHOST}/${this.userType}/qcm/shops/${shopId}/report`
      //   + `?from=${from}&to=${to}`
      // );
      // this.dialog.export.show = false;
      axios.get(
        `${process.env.VUE_APP_APIHOST}/${this.userType}/qcm/shops/${shopId}/report-qcm3`
        + `?from=${from}&to=${to}`
      )
      .then(response => {
        let data = response.data;
        console.log(`exportReport: got report-qcm3 response`, data);
        window.open(data.url);
        this.dialog.export.show = false;
      })
      .catch(err => {
        console.error(`exportReport: failed to get report-qcm3 response`, err);
      });
    },
    sendReport() {
      let shop = this.dialog.export.shop;
      let from = moment(this.dialog.export.pickedDates[0]).format('YYYYMMDD');
      let to = moment(this.dialog.export.pickedDates[1]).format('YYYYMMDD');

      // if  ( moment(this.dialog.export.pickedDates[1]).diff( moment(this.dialog.export.pickedDates[0]), 'days') > 100 ) {
      //   this.$notify.error({
      //     //title: `報表區間過大`,
      //     message: '最大可撈取報表區間為3個月'
      //   });
      //   return; 
      // }
      let bccs = this.dialog.export.ccs.length? this.dialog.export.ccs.split(','): undefined;//FIXME: We did not check the regex of this string.

      axios.get(
        `${process.env.VUE_APP_APIHOST}/${this.userType}/qcm/shops/${shop.id}/report-qcm3`
        + `?from=${from}&to=${to}`
      )
      .then(response => {
        let data = response.data;
        console.log(`sendReport: got report-qcm3 response`, data);
        return axios.post(
          `${process.env.VUE_APP_APIHOST}/${this.userType}/qcm/shops/${shop.id}/send`,
          {
            "recipient": this.dialog.export.recipient,
            "bccs": bccs,
            "from": from, "to": to,
            "attachmentUrl": data.url
          }
        );
      })
      .then(response => {
        this.$message({
          type: 'success',
          message: `已寄送 ${shop.shop_name} 的報表到 ${this.dialog.export.recipient}。`
        });
      })
      .catch(err => {
        this.$notify.error({
          title: `無法寄送報表給店家 ${shop.shop_name}：${this.dialog.export.recipient}`,
          message: err.data.message
        });
      });

      this.dialog.export.show = false;
    },

    /// Computed variables

    sendPeriodStyle(v) {
      return {
        '1:m': 'primary',
        '1:w': 'warning',
        '1:d': 'info',
        '0': 'default'
      }[v];
    }

  },

  data() {
    return {
      shops: [],
      total: 0, startIndex: 0, limit: 10, sort: 'id:asc', searchKeyword: '',

      sis: [],
      selectedSiId: null,

      formulas: [],

      isLoading: false,

      dialog: {
        siEdit: {
          show: false,
          si: { },
          selectedFormulaId: 0,
          selectedSendPeriod: '1:w',
          applyToShops: false
        },
        shopEdit: {
          show: false,
          shop: { },
          selectedFormulaId: 0,
          selectedSendPeriod: '1:w'
        },
        mailing: {
          show: false,
          ml: {}, 
          recipient: '',
          ccs: ''
        },
        export: {
          show: false,
          shop: { },
          sendMode: false,
          pickedDates: [ moment().startOf('isoWeek').toDate(), new Date() ],
          recipient: '',
          ccs: ''
        }
      },

      // Constants
      cols: [
        { key: 'id', label: '#', width: 72, sortable: true },
        { key: 'shop_name', label: '店家', width: 180, sortable: true },
        { key: 'formula_name', label: '公式／寄送週期', width: 250, align: 'left' },
        { key: 'si_name', label: '經銷商', width: 120, sortable: true },
        { key: 'si_formula_name', label: '經銷商預設', width: 250, align: 'left' },
        { key: 'actions', label: '' }
      ],
      sendPeriodOptions: [
        { label: '每月寄送', val: '1:m' },
        { label: '每週寄送', val: '1:w' },
        { label: '每日寄送', val: '1:d' },
        { label: '不寄送', val: '0' }
      ],
      datePickerOptions: {
        shortcuts: [{
          text: ' 本週',
          onClick(picker) {
            picker.$emit('pick', [
              moment().startOf('isoWeek').toDate(),
              moment().endOf('day').toDate()
            ]);
          }
        }, {
          text: '本月',
          onClick(picker) {
            picker.$emit('pick', [
              moment().startOf('month').toDate(),
              moment().endOf('day').toDate()
            ]);
          }
        }, {
          text: '上個月',
          onClick(picker) {
            picker.$emit('pick', [
              moment().add(-1, 'months').startOf('month').toDate(),
              moment().add(-1, 'months').endOf('month').toDate()
            ]);
          }
        }]
      },
      errorMessage: null
    };
  },

  computed: {
    urlShopSettings() {
      return `${process.env.VUE_APP_APIHOST}/${this.userType}/qcm/shops`
        + `?f=b`
        + (this.selectedSiId && this.selectedSiId !== ''? `&siId=${this.selectedSiId}`: '')
        + (this.searchKeyword.length? `&keyword=${this.searchKeyword}`: '');
    },

    user() {
      return this.$store.getters.user;
    },
    userType() {
      return this.$store.getters.userType;
    }
  },

  filters: {
    sendPeriodLiteral(v) {
      return {
        '1:m': '每月寄送',
        '1:w': '每週寄送',
        '1:d': '每日寄送',
        '0': '不寄送'
      }[v];
    }
  },

  watch: {
    'dialog.export.pickedDates': {
      deep: true,
      handler(val) {
        if  (moment(val[1]).diff( moment(val[0]), 'days') > 100 ) {
          this.errorMessage = '最大可撈取區間為3個月';
        } else {
          this.errorMessage = null;
        }
      }
    }
  }
}
</script>

<style scoped>

</style>